/**
 * PHSIMS Developer Portal — Color Tokens
 * Subset of the main design system for the independent developer portal.
 */

export const ZAMBIA = {
  forest:     '#0d5c2e',
  forestLight:'#198a4b',
  forestDark: '#094a24',
  copper:     '#c87533',
  copperLight:'#d4915a',
  copperDark: '#a35e28',
  ember:      '#b42318',
} as const;

export const SEMANTIC = {
  attention:    '#b45309',
  attentionBg:  '#fef3c7',
  danger:       '#b42318',
  dangerBg:     '#fde8e6',
  positive:     '#0d5c2e',
  positiveBg:   '#e6f4ec',
  insight:      '#3730a3',
  insightBg:    '#e8e7f5',
  neutral:      '#475569',
  neutralBg:    '#f1f5f9',
} as const;

export const CHART = {
  series: [
    '#0d5c2e', '#1e4d8c', '#92400e', '#5b21b6', '#b45309',
    '#0e7490', '#6b4226', '#7e22ce', '#0369a1', '#a16207',
  ],
} as const;

export const SURFACE = {
  page:    '#f8fafb',
  card:    '#ffffff',
  raised:  '#ffffff',
  muted:   '#f1f5f9',
  divider: '#e2e8f0',
  border:  '#cbd5e1',
} as const;

export const TEXT = {
  primary:   '#1e293b',
  secondary: '#64748b',
  tertiary:  '#94a3b8',
  inverse:   '#ffffff',
  link:      '#0d5c2e',
} as const;
